import { render } from "./QuestionnaireWebform.vue?vue&type=template&id=4e7915d2"
import script from "./QuestionnaireWebform.vue?vue&type=script&lang=js"
export * from "./QuestionnaireWebform.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__